<div *ngIf="!validating">
    <app-not-found *ngIf="!isValidToken"></app-not-found>
    <div *ngIf="isValidToken" class="container py-4 clearfix">
        <div *ngIf="appointment.confirmed">
            <h4 style="text-align: center;">{{ 'APPOINTMENT-CONFIRMED' | translate}}</h4>
        </div>
        <div *ngIf="!appointment.confirmed">
            <h4 style="text-align: center;">{{ 'APPOINTMENT-CANCELLED' | translate}}</h4>
        </div>
        <br /><br />
        <div class="col-12">
            <div *ngIf="appointment.confirmed" class="row">
                <div class="col-12" style="text-align: center;">
                    <span translate
                        [translateParams]="{title: appointment.title, provider: appointment.providerFullName}">{{'APPOINTMENT-CONFIRMED-INFO'}}</span>
                    {{event.eventDateTime | date:'medium'}}
                </div>
            </div>
            <div *ngIf="!appointment.confirmed" class="row">
                <div class="col-12" style="text-align: center;">
                    <span translate
                        [translateParams]="{title: appointment.title, provider: appointment.providerFullName}">{{'APPOINTMENT-CANCELLED-INFO'}}</span>
                    {{event.eventDateTime | date:'medium'}}
                </div>
            </div>
        </div>
    </div>
</div>